import { PluggableMap } from "ol";
import { Listener } from "ol/events";
import BaseEvent from "ol/events/Event";
import PointerInteraction from "ol/interaction/Pointer";
import DeleteTrackEvent from "./DeleteTrackEvent";
import HomeEvents from "./HomeEvents";
import InfoMessageEvent from "./InfoMessageEvent";
import PreUndoEvent from "./PreUndoEvent";
import {Options} from 'ol/interaction/Pointer.js';

interface EventSpec {
    type: string;
    listener: Listener;
}
export default class EventRememberingPointerInteraction extends PointerInteraction implements HomeEvents {
    constructor(pointerOptions?: Options) {
        super(pointerOptions);
    }

    eventsAdded = [] as EventSpec[]

    addEventListener(type: string, listener: Listener): void {
        this.eventsAdded.push({listener: listener, type: type})
        super.addEventListener(type, listener)
        
    }

    removeAllEventListeners() {
        this.eventsAdded.forEach(e => this.removeEventListener(e.type, e.listener))
    }

    removeEventListener(type: string, listener: Listener): void {
        super.removeEventListener(type, listener)
    }

    dispose(): void {
        this.removeAllEventListeners()
        super.dispose()
    }

    handlePreUndoEvent(preUndoEvent: PreUndoEvent): void {
        this.dispatchEvent(preUndoEvent)
    }
    handleDeleteTrackEvent(deleteTrackEvent: DeleteTrackEvent): void {
        this.dispatchEvent(deleteTrackEvent)
    }
    handleInfoMessageEvent(infoMessageEvent: InfoMessageEvent): void {
        this.dispatchEvent(infoMessageEvent)
    }
    handleFinishedDrawingEvent(finishedDrawingEvent: BaseEvent): void {
        this.dispatchEvent(finishedDrawingEvent)
    }

    getMap(): PluggableMap {
        return super.getMap()!
    }
}